"use strict";

const moment = require("moment");

module.exports = function(time) {
	return moment(time).format("D MMMM YYYY");
};



// WEBPACK FOOTER //
// ./client/js/libs/handlebars/localedate.js